<template>
  <div class="dynamic-box" @contextmenu.prevent>
    <div class="dynamic-box-top">
      <div v-show="!messageDetails" class="top-left">
        {{ $t("homeFirst.Activity") }}
      </div>
      <div
        @click="messageDetails = false"
        v-show="messageDetails"
        class="top-left arrowa"
      >
        <div class="arrow-box">
          <svg-btn class="right-time" icon-class="icon-arrow-right"></svg-btn>
        </div>
        {{ $t("homeFirst.MoreActivity") }}
      </div>
      <div class="top-right">
        <div class="left-time1">
          <div
            :class="$store.state.actIndex == 1 ? 'actIndexact' : ''"
            class="act"
            @click="actIndexFn(1)"
          >
            {{ $t("homeFirst.ThisMonth") }}
          </div>
          <div
            :class="$store.state.actIndex == 2 ? 'actIndexact' : ''"
            class="act"
            @click="actIndexFn(2)"
          >
            {{ $t("homeFirst.LastMonths") }}
          </div>
        </div>
        <div class="svg-box" @click="showdynamicSetting = true">
          <svg-btn class="right-time1" icon-class="icon-account"></svg-btn>
        </div>
      </div>
    </div>
    <!-- 消息类型 -->
    <div class="message-list" v-show="!messageDetails">
      <!-- 转存文件消息 -->
      <div
        v-for="(item, index) in messagelist"
        :key="index"
        class="message-item"
        @click="messageFn(item)"
      >
        <div
          :style="{ boxShadow: item.count == 1 ? 'none' : '' }"
          class="item-1"
        >
          <div class="info-box">
            <img class="icon" :src="item.icon" alt="" srcset="" />
            <div class="text-box" :style="{justifyContent: item.content?.length > 0 ? 'left' : 'center',paddingTop: item.content?.length > 0 ? '4px' : '0px'}">
              <div class="text1">
                <div class="type">{{ item.type_name }}</div>
                <div class="title">
                  {{ item.title }}
                </div>
              </div>
              <div class="text2">
                <div class="type" v-for="items in item.content" :key="items" v-html="items.replace(/\n/g, '<br>')">
                </div>
              </div>
            </div>
          </div>
          <div class="time">
            {{ item.create_time
            }}<svg-btn class="le" icon-class="icon_direction_right"></svg-btn>
          </div>
        </div>
        <div v-if="item.count > 1" class="item-2"></div>
        <div v-if="item.count > 2" class="item-3"></div>
      </div>
      <div class="Dynamic_default" v-show="messagelist.length <= 0">
        <img
          class="icon_Dynamic_default"
          :src="$utils.getPng('icon_Dynamic_default')"
          default
          alt=""
          srcset=""
        />
        <div class="icon_Dynami">暂无动态</div>
      </div>
    </div>
    <div class="message-list2" v-show="messageDetails">
      <!-- 转存文件消息 -->
      <div
        v-for="(item, index) in messagelist2"
        :key="index"
        class="message-item"
        @click="messageFn2(item)"
      >
        <div
          :style="{ boxShadow: item.count == 1 ? 'none' : '' }"
          class="item-1"
        >
          <div class="info-box">
            <div :class="item?.fshort ? 'icon2' : 'icon'">
              <img class="icon-img" :src="item.icon" alt="" srcset="" />
            </div>
            <div class="text-box" :style="{justifyContent: item.content?.length > 0 ? 'left' : 'center',paddingTop: item.content?.length > 0 ? '4px' : '0px'}">
              <div class="text1">
                <div class="type">{{ item.type_name }}</div>
                <div class="title">
                  {{ item.title }}
                </div>
              </div>
              <div class="text2-title" v-if="item.content_title">
                {{ item.content_title }}
              </div>
              <div class="text2">
                <div class="type" v-for="items in item.content" :key="items" v-html="items.replace(/\n/g, '<br>')">
                </div>
              </div>
              <div v-if="item?.content_img" class="text3">
                <img :src="item.content_img" alt="" srcset="" />
              </div>
              <div class="time-box">
                <div class="time">{{ item.create_time }}</div>
                  <svg-btn
                    v-if="![5, 6, 7, 8].includes(+item.type) && !(item.type == 9 && !item?.jump_url)"
                    class="le"
                    icon-class="icon_direction_right"
                  ></svg-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="Dynamic_default"
        v-show="messagelist2.length <= 0 && !loading"
      >
        <img
          class="icon_Dynamic_default"
          :src="$utils.getPng('icon_Dynamic_default')"
          default
          alt=""
          srcset=""
        />
        <div class="icon_Dynami">暂无动态</div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-box">
        <div class="loading-spinner"></div>
        <span class="loading-text">加载中...</span>
      </div>

      <!-- 无更多数据提示 -->
      <div v-if="!hasMore && messagelist2.length > 0" class="no-more-box">
        <div class="no-more-text">
          {{
            actIndex === 1
              ? "已加载本月动态，可切换查看近三个月动态"
              : "暂无更多动态，最多展示近三个月动态"
          }}
        </div>
      </div>
    </div>
    <dynamicSetting
      :isShow="showdynamicSetting"
      @handleClose="showdynamicSetting = false"
      @SwitchObj="SwitchObjFn"
    ></dynamicSetting>
  </div>
</template>

<script>
import { webHome, getDynamicDetails } from "@/utils/apiList/usermsg";
import dynamicSetting from "@/components/dynamicSetting/index.vue";
export default {
  components: { dynamicSetting },
  name: "dynamic",
  data() {
    return {
      actIndex: 1,
      length: 3,
      messageDetails: false,
      messagelist: [],
      messagelist2: [],
      showdynamicSetting: false,
      page: 1,
      typess: "",
      loading: false,
      hasMore: true,
    };
  },
  watch: {
    messageDetails(newVal, oldVal) {
      if (!newVal) {
        // this.messagelist = [];
        this.webHomeFn();
      }
    },
    "$store.state.actIndex"(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.messageDetails) {
          this.page = 1;
          this.hasMore = true;
          this.loading = false;
          this.getDynamicDetailsFn();
        } else {
          this.webHomeFn();
        }
      }
    },
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    SwitchObjFn(){
      if(this.messageDetails){
        this.messageDetails = false
      } else {
        this.messagelist = [];
        this.webHomeFn();
      }
    },
    actIndexFn(index) {
      this.actIndex = index;
      this.$store.commit("setAttr", {
        name: "actIndex",
        val: index,
      });
      localStorage.setItem('actIndex', index)
    },
    handleScroll() {
      // 只有在详情页面才需要滚动加载
      if (!this.messageDetails) return;

      // 如果正在加载或没有更多数据，则不执行
      if (this.loading || !this.hasMore) return;

      // 获取滚动位置
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 当滚动到距离底部100px时开始加载
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.getDynamicDetailsFn();
      }
    },
    messageFn(item) {
      const validTypes = new Set([10, 11, 12, 14, 15]);
      const validTypes2 = new Set([1, 4, 17]);
      const validTypes3 = new Set([9]);
      const validTypes4 = new Set([5, 6, 7, 8]);
      if (validTypes4.has(+item.type) && item.count == 1) {
        this.$toast("请前往Feemoo APP-设备管理查看", 2);
        return;
      } else if (validTypes.has(+item.type) && item.count == 1) {
        this.$router.push({ path: "/vip" });
      } else if (item.type == 16 && item.count == 1) {
        this.$router.push({ path: "/recycle" });
      } else if ((item.type == 2 || item.type == 3) && item.count == 1) {
        this.$router.push({ path: "/collectionSet" });
      } else if (item.type == 18 && item.count == 1) {
        this.$router.push({ path: "/myCollection" });
      } else if (item.type == 13 && item.count == 1) {
        // 跳转到对应的下载页
        sessionStorage.setItem("isFromShareList", 1);
        if (item?.go_url) {
          this.$router.push({
            path:
              "/s/" +
              item.fshort +
              "?pucode=" +
              item?.go_url +
              "#取件码：" +
              item?.go_url,
          });
        } else {
          this.$router.push({ path: "/s/" + item.fshort });
        }
      } else if (validTypes2.has(+item.type) && item.count == 1) {
        // 点击后跳转至文件-文件所在路径
        this.foldergo(item.folder_id, item.folder_name);
      } else if (validTypes3.has(+item.type) && item.count == 1) {
        if (item?.mtid == 6) {
          this.$toast("请前往Feemoo APP-福利社-查看卡卷包", 2);
          return;
        }
        this.page = 1;
        this.hasMore = true;
        this.loading = false;
        this.getDynamicDetailsFn(item.type);
      } else {
        this.page = 1;
        this.hasMore = true;
        this.loading = false;
        this.getDynamicDetailsFn(item.type);
      }
    },
    messageFn2(item) {
      const validTypes = new Set([10, 11, 12, 14, 15]);
      const validTypes2 = new Set([1, 4, 17]);
      const validTypes3 = new Set([9]);
      const validTypes4 = new Set([5, 6, 7, 8]);
      if (validTypes4.has(+item.type)) {
        this.$toast("请前往Feemoo APP-设备管理查看", 2);
        return;
      } else if (validTypes.has(+item.type)) {
        this.$router.push({ path: "/vip" });
      } else if (item.type == 16) {
        this.$router.push({ path: "/recycle" });
      } else if (item.type == 2 || item.type == 3) {
        this.$router.push({ path: "/collectionSet" });
      } else if (item.type == 18) {
        this.$router.push({ path: "/myCollection" });
      } else if (item.type == 13) {
        // 跳转到对应的下载页
        sessionStorage.setItem("isFromShareList", 1);
        if (item?.go_url) {
          this.$router.push({
            path:
              "/s/" +
              item.fshort +
              "?pucode=" +
              item?.go_url +
              "#取件码：" +
              item?.go_url,
          });
        } else {
          this.$router.push({ path: "/s/" + item.fshort });
        }
      } else if (validTypes2.has(+item.type)) {
        // 点击后跳转至文件-文件所在路径
        this.foldergo(item.folder_id, item.folder_name);
      } else {
        if (validTypes3.has(+item.type)) {
          if (item?.mtid == 6) {
            this.$toast("请前往Feemoo APP-福利社-查看卡卷包", 2);
            return;
          }
          if (item?.jump_url) {
            window.open(item.jump_url, "_blank");
          }
        }
      }
    },
    webHomeFn() {
      this.actIndex = this.$store.state.actIndex;
      webHome({ date: this.actIndex }).then((res) => {
        if (res.status == 1) {
          this.messagelist = res.data.dynamic;
          this.$store.commit("setAttr", {
            name: "daily_tasks",
            val: res.data.user_info?.daily_tasks,
          });
        }
      });
    },
    getDynamicDetailsFn(type) {
      if (type) this.typess = type;

      // 如果正在加载或没有更多数据，则不执行
      if (this.loading || !this.hasMore) {
        return Promise.resolve();
      }

      this.loading = true;
      this.actIndex = this.$store.state.actIndex;
      const params = {
        page: this.page,
        limit: 30,
        type: this.typess,
        date: this.actIndex,
      };
      return getDynamicDetails(params)
        .then((res) => {
          this.loading = false;
          if (res.status == 1) {
            // 如果是第一页，替换数据；否则追加数据
            if (this.page === 1) {
              this.messagelist2 = res.data.list;
              this.hasMore = res.data.list.length >= 30; // 如果返回的数据少于限制数量，说明没有更多数据
              this.messageDetails = true;
            } else {
              this.messagelist2 = [...this.messagelist2, ...res.data.list];
              // 如果返回的数据少于限制数量，说明没有更多数据
              if (res.data.list.length < 30) {
                this.hasMore = false;
              }
            }
            this.page++;
          } else {
            this.hasMore = false;
          }
          return res;
        })
        .catch((error) => {
          this.loading = false;
          this.hasMore = false;
          console.error("获取动态详情失败:", error);
          return Promise.reject(error);
        });
    },
    foldergo(folder_id, folder_name) {
      const folderData = {
        folder_id: folder_id || 0,
        name: folder_name || "",
        action: "openFolder", // 标识需要执行openFolder操作
      };
      if (folder_id != 0) {
        localStorage.setItem("openFolder", JSON.stringify(folderData));
      }

      this.$router.push({ path: "/drive" });
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-box {
  margin-top: 32px;
  .dynamic-box-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .top-left {
      font-weight: 600;
      font-size: 16px;
      @include useTheme {
        color: getVar("text-color1-2c2c2c");
      }
      line-height: 24px;
    }

    .arrowa {
      font-weight: 500;
      font-size: 14px;
      @include useTheme {
        color: getVar("text-color1-8a8b92");
      }
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .arrow-box {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          @include useTheme {
            background-color: getVar("bg-color-ebebeb");
          }
          cursor: pointer;
        }

        .right-time {
          width: 18px;
          height: 18px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
          transform: rotate(180deg);
        }
      }
    }

    .top-right {
      display: flex;
      align-items: center;

      .left-time1 {
        display: flex;
        align-items: center;
        padding: 0 3px;
        // width: 126px;
        height: 32px;
        @include useTheme {
          background-color: getVar("bg-color-ebebeb");
        }
        border-radius: 20px;

        .act {
          display: flex;
          align-items: center;
          padding: 0 12px;
          font-weight: 400;
          font-size: 12px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
          line-height: 20px;
          cursor: pointer;

          &:hover {
            @include useTheme {
              color: getVar("text-color1-2c2c2c");
            }
          }
        }

        .actIndexact {
          height: 26px;
          @include useTheme {
            color: getVar("text-color1-2c2c2c");
          }
          @include useTheme {
            background-color: getVar("bg-color-fill1");
          }
          border-radius: 20px;
        }
      }

      .svg-box {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        cursor: pointer;

        &:hover {
          @include useTheme {
            background-color: getVar("bg-color-ebebeb");
          }
        }
        .right-time1 {
          width: 18px;
          height: 18px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
        }
      }
    }
  }

  .Dynamic_default {
    margin: auto;
    margin-top: 140px;
    text-align: center;

    .icon_Dynamic_default {
      width: 100px;
      height: 100px;
    }

    .icon_Dynami {
      font-size: 16px;
      line-height: 24px;
      margin-top: 8px;
      @include useTheme {
        color: getVar("text-color1-2c2c2c");
      }
    }
  }

  .message-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    padding-bottom: 72px;
    // gap: 12px;

    .message-item {
      position: relative;
      margin-bottom: 12px;

      .item-1 {
        position: relative;
        padding: 18px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill1");
        }
        border-radius: 20px;
        z-index: 10;
        box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .info-box {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          .icon {
            width: 44px;
            height: 44px;
          }
          .text-box {
            display: flex;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            padding-top: 4px;
            .text1 {
              display: flex;
              margin-left: 10px;
              .type {
                font-weight: 500;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
                margin-right: 6px;
              }
              .title {
                font-weight: 400;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
              }
            }

            .text2 {
              margin-left: 10px;
              max-width: calc(100% - 10px);

              .type {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-52565a");
                }
                margin-top: 2px;
                line-height: 16px;
                /* 添加以下属性实现两行缩略 */
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
          }
        }

        .time {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 12px;
          @include useTheme {
            color: getVar("text-color1-8a8b92");
          }
          line-height: 20px;
          flex-shrink: 0;
          margin-left: 20px;
          .le {
            width: 16px;
            height: 16px;
            margin-left: 2px;
            flex-shrink: 0;
          }
        }
      }
      .item-2 {
        position: relative;
        margin: -22px 12px 0 12px;
        padding: 14px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill12");
        }
        border-radius: 20px;
        z-index: 9;
        box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.04);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .item-3 {
        position: relative;
        margin: -22px 24px 0 24px;
        padding: 14px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill13");
        }
        border-radius: 20px;
        z-index: 8;
        box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.04);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
  }

  .message-list2 {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    padding-bottom: 72px;
    // gap: 12px;

    .message-item {
      position: relative;
      margin-bottom: 12px;

      .item-1 {
        position: relative;
        padding: 18px 12px;
        @include useTheme {
          background-color: getVar("bg-color-fill1");
        }
        border-radius: 20px;
        z-index: 10;
        // box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .info-box {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          width: 100%;
          .icon {
            width: 44px;
            height: 44px;
            display: flex;
            justify-content: center;
            align-items: center;

            .icon-img {
              width: 44px;
              height: 44px;
            }
          }
          .icon2 {
            width: 44px;
            height: 44px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0; /* 防止被压缩 */
            min-width: 44px; /* 确保最小宽度 */
            box-sizing: border-box; /* 确保盒模型正确 */

            .icon-img {
              width: 36px;
              height: 36px;
            }
          }
          .text-box {
            display: flex;
            justify-content: center;
            flex-direction: column;
            width: 100%;
            padding-top: 4px;
            .text1 {
              display: flex;
              margin-left: 10px;
              .type {
                font-weight: 500;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
                margin-right: 6px;
              }
              .title {
                font-weight: 400;
                font-size: 13px;
                @include useTheme {
                  color: getVar("text-color1-2c2c2c");
                }
                line-height: 18px;
              }
            }

            .text2-title {
              margin-left: 10px;
              font-weight: 400;
              font-size: 13px;
              margin-top: 4px;
              @include useTheme {
                color: getVar("text-color1-2c2c2c");
              }
              line-height: 18px;
              word-break: break-all;
              word-wrap: break-word;
              overflow-wrap: break-word;
              max-width: calc(100% - 10px);
            }

            .text2 {
              margin-left: 10px;
              max-width: calc(100% - 10px);

              .type {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-52565a");
                }
                margin-top: 2px;
                line-height: 16px;
                text-align: justify;
                word-break: break-all;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
            }
            .text3 {
              width: 320px;
              height: 178px;
              margin-top: 8px;
              margin-bottom: 8px;
              margin-left: 10px;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .time-box {
              margin-top: 4px;
              margin-left: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .time {
                font-weight: 400;
                font-size: 11px;
                @include useTheme {
                  color: getVar("text-color1-8a8b92");
                }
                line-height: 16px;
                flex-shrink: 0;
              }
              .le {
                width: 16px;
                height: 16px;
                margin-left: 2px;
                flex-shrink: 0;
                @include useTheme {
                  color: getVar("text-color1-8a8b92");
                }
              }
            }
          }
        }
      }
    }
  }

  // 加载状态样式
  .loading-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin-top: 12px;

    .loading-spinner {
      width: 16px;
      height: 16px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid #2c2c2c;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-right: 8px;
    }

    .loading-text {
      font-size: 12px;
      @include useTheme {
        color: getVar("text-color1-8a8b92");
      }
    }
  }

  // 无更多数据样式
  .no-more-box {
    display: flex;
    align-items: center;
    justify-content: center;
    // padding: 20px;
    margin-top: 12px;

    .no-more-text {
      font-size: 12px;
      @include useTheme {
        color: getVar("text-color1-8a8b92");
      }
      text-align: center;
      line-height: 18px;
    }
  }

  // 加载动画
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
